module.exports = __webpack_public_path__ + "img/01-T.44d24ace.jpg";